/* The Honey Colony — routing between the designed story pages and real Shopify URLs.
   Each Shopify page (home, collection, product, journal, wholesale, gifting) hosts one
   part of the story. In-page states still use the prototype's "#/..." routes, and any
   route that belongs to a different Shopify page becomes a normal page load. */
(function () {
  'use strict';
  var T = window.THC || (window.THC = {});
  T.route = window.THC_ROUTE || null;
  T.native = !T.route;

  function parse(hash) {
    var raw = String(hash || '').replace(/^#\/?/, '');
    var parts = raw.split('?');
    return { path: parts[0] || '', params: new URLSearchParams(parts[1] || '') };
  }

  // Which Shopify page a "#/..." route belongs to.
  T.keyFor = function (hash) {
    var r = parse(hash), path = r.path, params = r.params;
    if (path.indexOf('product') === 0) return 'product:' + (params.get('id') || 'manuka');
    if (path === 'collection') return 'collection:' + (params.get('edition') || 'manuka');
    if (path === 'journal' || path.indexOf('journal/') === 0) return 'journal';
    if (path === 'wholesale') {
      var offer = params.get('offer');
      if (offer === 'corporate') return 'corporate-gifting';
      if (offer === 'wedding') return 'wedding-favours';
      return 'wholesale';
    }
    if (["private-label", "hospitality-foodservice", "door-gifts", "stockists", "workplace", "agency-partners", "seasonal-festive-gifts"].includes(path)) return path;
    if (path === 'corporate-gifting' || path === 'wedding-favours') return path;
    return 'home';
  };

  // The Shopify URL for a page key, or null when it has no page in the shop.
  T.urlFor = function (key) {
    var R = T.routes || {}, pages = R.pages || {};
    if (key === 'home') return R.root || '/';
    if (key.indexOf('collection:') === 0) return T.collections[key.slice(11)]?.url || R.collection || '/collections/all';
    if (key.indexOf('product:') === 0) {
      var p = (T.products || {})[key.slice(8)];
      return p && p.url ? p.url : null;
    }
    return pages[key] || null;
  };

  T.currentKey = T.route ? T.keyFor(T.route) : null;

  // On load, make sure the hash describes this page before the story app reads it.
  if (T.route) {
    var h = location.hash;
    if (h.indexOf('#/') !== 0 || T.keyFor(h) !== T.currentKey) {
      history.replaceState(history.state, '', location.pathname + location.search + T.route);
    }
  }

  // Runs before the app's own hashchange listeners (this script loads first).
  window.addEventListener('hashchange', function (e) {
    var h = location.hash;
    if (h.indexOf('#/') !== 0) return;
    var key = T.keyFor(h);
    if (key === T.currentKey) return; // same Shopify page: let the app render in place
    var url = T.urlFor(key);
    if (!url && !T.native) return;    // not in the shop yet: show the designed view in place
    e.stopImmediatePropagation();
    location.replace((url || T.urlFor('collection')) + (url ? h : ''));
  });
})();
